import { EventDetail, EventListItem } from '../types/content';
import { createPublicCatalogCache } from './publicCatalogCache';

export const eventCatalogCache = createPublicCatalogCache<EventListItem, EventDetail>();

export function filterPublicEvents(
  events: EventListItem[],
  opts: {
    search?: string;
    categoryId?: string | number;
  }
) {
  const term = (opts.search || '').trim().toLowerCase();
  const search = term.length >= 3 ? term : '';
  const categoryId = opts.categoryId ? String(opts.categoryId) : '';

  return events.filter((event) => {
    if (categoryId && String(event.categoryId || '') !== categoryId) return false;
    if (!search) return true;
    return [event.title, event.subtitle, event.summary, event.location, event.categoryName, event.speakerName]
      .some((value) => (value || '').toLowerCase().includes(search));
  });
}
